This policy forms part of, and is governed by the Customer Agreement and/or the
SipSignal Terms of Service, as applicable. Terms used herein but not otherwise
defined shall have the meanings ascribed to them in the Agreement or the Terms
of Service. <br /><br />
SipSignal provides access to emergency calling services, allowing most SipSignal
users to access either basic 911 or Enhanced 911 (E911) service. SipSignal users
with a Digital Line, using IP Desk Phones or Softphones, can dial 911 directly
from their IP Desk Phones or Softphone. VIRTUAL EXTENSIONS AND MOBILE USERS
WITHOUT A DIGITAL LINE CANNOT COMPLETE 911 CALLS. <br /><br />
Emergency calling services work differently than you may have experienced using
traditional wireline or wireless telephones. Your access may differ depending on
your location or the device you are using.
<br /><br />
<section>
  <h2 class="legal__subtitle">1. Registering Your Location</h2>
  You must register the address of the physical location where you will use each
  Digital Line with SipSignal immediately upon activation of your End Point.
  This is your Registered Address. You or your Account Administrator must
  accurately register each individual line through your Digital Line Settings or
  the Administrative Portal. You must use SipSignal voice services only at the
  Registered Address provided for the applicable Digital Line. If you move a
  registered device, you must immediately update the Registered Address with the
  new physical location of the device with SipSignal through the Administrative
  Portal or in your account settings. If you do not update the Registered
  Address, any 911 calls made from the device may be sent to the wrong emergency
  response center and will not transmit your current location information to
  emergency responders, delaying emergency assistance to you. It may take up to
  several hours for the address update to take effect. Customers with more than
  one Digital Line are solely responsible for ensuring that an accurate and
  up-to-date Registered Address is maintained for each Digital Line, and that
  their End Users are aware of how the Registered Address can be changed.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">2. Service limitations</h2>
  SipSignal 911 service will not function (i) in the event of an Internet or
  power outage; (ii) if your broadband, ISP, or SipSignal Service is terminated;
  (iii), with respect to only the SipSignal Mobile Application, if you do not
  have mobile service, as the SipSignal Mobile Application cannot send emergency
  calls over Wi-Fi access; and (iv) in some Global Office countries. It is
  possible that network congestion may delay or prevent completion of any 911
  call. You will not be able to complete a 911 call if you move to a physical
  location outside the country in which your Digital Line is provided, or if you
  are dialing from a SipSignal number that is not a Canadian or United States
  number.
</section>
<br /><br />
Users uncomfortable with any of these limitations should use an alternate means
of reaching 911.
<br /><br />
<section>
  <h2 class="legal__subtitle">3. How it Works</h2>
  When you dial 911 using voice services from SipSignal, the SipSignal phone
  number and the Registered Address you have provided is sent to the local
  emergency center serving your location. In some areas, emergency operators
  have access to this information; however, in areas where only basic 911
  service is available, the emergency operator answering the call may not be
  able to see your SipSignal telephone number or your Registered Address. You
  should always be prepared to provide the emergency operator with your
  SipSignal telephone number and Registered Address in case the call is dropped
  or disconnected. If you are unable to speak, the emergency operator may not be
  able to send help to your location and/or call you back should the call be
  disconnected. SipSignal does not control whether or not the emergency operator
  receives your telephone number and Registered Address.
  <br /><br />
  In some cases, 911 calls dialed from your SipSignal device cannot be directed
  to the local emergency response center, and are instead directed to a National
  Emergency Call Center (the “NECC”). That might happen if there is a problem
  validating a Registered Address, if the Registered Address is an international
  location, or if the Registered Address is in an area that is not covered by
  the landline 911 network. 911 calls that are directed to the NECC may not
  include your SipSignal telephone number or your registered address. Trained
  operators at the NECC will request your name, location, and telephone number
  and attempt to reach emergency responders in your local area. Until you give
  the operator your phone number, and location, he/she may not be able to call
  you back or dispatch help to your location if the call is dropped or
  disconnected. You may verify if your emergency calling services is activated
  and verify if address is correct by dialing 933.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">4. Mobile Applications</h2>
  Calls to 911 placed through the SipSignal Mobile Application on a smartphone
  are automatically routed to the native dialer on the smartphone, and the call
  will be handled by your wireless service provider if wireless service is
  available. If your wireless service is unavailable, the 911 call cannot be
  placed. The SipSignal Mobile Application cannot place emergency calls over
  Wi-Fi access. Emergency dialing is not available through the SipSignal Mobile
  Application on tablets or other mobile devices without a native phone dialer
  and a wireless service plan.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">
    5. Notification of Employees, Guests, or Other Users
  </h2>
  Customers must notify any employees, contractors, guests, or persons who may
  place calls using the Services or may be present at the physical location
  where the Services may be used, of the limitations of SipSignal 911 Service
  from your SipSignal IP phone, other equipment, or the SipSignal Softphone.
  Customer must affix a sticker warning that 911 services may be limited or
  unavailable in a readily visible place on each piece of equipment that might
  be used to access or use the Services, as required by 47 C.F.R. § 9.5.
</section>
<br /><br />
<section>
  <h2 class="legal__subtitle">
    6. Disclaimer of Liability for Emergency Call Response
  </h2>
  Your use, and use by your employees, guests and other third parties, of
  SipSignal’s 911 Services are subject to the limitations described herein. The
  availability of certain features, such as transmission of a Registered Address
  or your SipSignal telephone number, depends on whether local emergency
  response centers support those features, and other factors outside of
  SipSignal’s control. SipSignal relies on qualified third parties to assist us
  in routing 911 calls to local emergency response centers and to the NECC.
  SipSignal does not have control over local emergency response centers, the
  NECC, emergency responders, or other third parties. SipSignal disclaims all
  responsibility for the conduct of local emergency response centers, the NECC,
  third parties engaged by Customer to facilitate address updates, and all other
  third parties involved in the provision of emergency response services. To the
  extent permitted by applicable Law, you hereby release, discharge, and hold
  harmless SipSignal from and against any and all liability relating to or
  arising from any acts or omissions of such third parties or other third
  parties involved in the handling of or response to any emergency or 911 call.
  <br /><br />
  Customer indemnifies and holds harmless SipSignal, and any third-party
  provider(s) from any and all third-party claims, losses, damages, fines, or
  penalties arising out of: (i) Customer or its End User’s provision to
  SipSignal of incorrect information, including physical addresses, or failure
  to update a Registered Address; (ii) Customer’s failure to properly notify any
  person who may place calls using the Services of the 911 limitations; or (iii)
  the absence, failure, or outage of emergency service dialing using the
  Services for any reason; and (iv) the inability of any End User to be able to
  dial 911 or access emergency service personnel for any reason.
</section>
